export const getConfig = async () => {
  return await fetch('/config.json')
    .then(response => response.json())
    .catch(() => {
      return {};
    });
};
